import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * 컨테이너 너비 제어 컴포넌트 (전역)
 * 원본: container-width-control.html
 */
const ContainerWidthControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const containerWidths = currentThemeConfig.containerWidths || { xl: 1400, lg: 992, md: 768, sm: 576 };

  const updateContainerWidth = (size, value) => {
    const numValue = parseInt(value, 10);
    if (isNaN(numValue) || numValue < 0 || numValue > 5000) return;
    set(`containerWidths.${size}`, numValue);
    const varName = `--container-max-width-${size}`;
    document.documentElement.style.setProperty(varName, `${numValue}px`);
  };

  return (
    <div id="container-width-control-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>📏 컨테이너 최대 너비:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="container-width-control-section"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="이 항목으로 이동"
          >
            ?
          </button>
        </div>
        <button
          type="button"
          onClick={() => {
            const defaults = { xl: 1400, lg: 992, md: 768, sm: 576 };
            Object.keys(defaults).forEach(size => {
              updateContainerWidth(size, defaults[size]);
            });
          }}
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            padding: '4px 10px',
            borderRadius: '3px',
            cursor: 'pointer',
            marginLeft: '6px'
          }}
        >
          리셋
        </button>
      </div>
      <div style={{ fontSize: '11px', color: '#999', marginBottom: '8px' }}>해상도별 설정:</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        {[
          { key: 'xl', label: 'XL (≥1400px):', default: 1400 },
          { key: 'lg', label: 'LG (992px~1199px):', default: 992 },
          { key: 'md', label: 'MD (768px~991px):', default: 768 },
          { key: 'sm', label: 'SM (576px~767px):', default: 576 }
        ].map(({ key, label, default: defaultValue }) => (
          <div key={key} style={{ position: 'relative' }}>
            <label style={{ display: 'block', fontSize: '11px', color: '#666', marginBottom: '4px' }}>{label}</label>
            <input
              type="number"
              value={containerWidths[key] || defaultValue}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (!isNaN(value) && value >= 0 && value <= 5000) {
                  updateContainerWidth(key, value);
                }
              }}
              onBlur={(e) => {
                const value = parseInt(e.target.value, 10);
                if (isNaN(value) || value < 0 || value > 5000) {
                  const currentValue = containerWidths[key] || defaultValue;
                  e.target.value = currentValue;
                  updateContainerWidth(key, currentValue);
                }
              }}
              step="1"
              min="0"
              max="5000"
              style={{
                width: '100%',
                padding: '6px 10px',
                paddingRight: '35px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '13px',
                fontFamily: 'monospace',
                textAlign: 'center'
              }}
            />
            <div style={{ position: 'absolute', right: '8px', bottom: '6px', fontSize: '11px', color: '#999', pointerEvents: 'none' }}>px</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContainerWidthControl;

